import styled from "styled-components";

export const TabContent = styled.div`
padding: 20px;
padding-top: 10px;
padding-bottom: 5px;
`;